import { inject, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class SwUpdateService {
  private readonly _swUpdate: SwUpdate = inject(SwUpdate);

  constructor() {
    if (this._swUpdate.isEnabled) {
      this._swUpdate.versionUpdates.subscribe(event => {
        switch (event.type) {
          case 'VERSION_READY':
            console.log('[SW] Neue Version gefunden → automatisch aktivieren...');
            this._swUpdate.activateUpdate().then(() => document.location.reload());
            break;
        }
      });
    }
  }

  public checkForUpdateEvery(hours: number) {
    if (!this._swUpdate.isEnabled) return;

    const intervalMs = hours * 60 * 60 * 1000;
    setInterval(() => {
      console.log('[SW] Checking for updates...');
      this._swUpdate.checkForUpdate();
    }, intervalMs);
  }
}
